// extracted by mini-css-extract-plugin
export default {"AppContainer":"AppContainer","ReportForm":"ReportForm"};